import { CheckoutComponent } from './index';

export default class CheckoutUserInfo {
    readonly profileTable = document.querySelector('.bx-soa-profile-table');

    readonly addProfile = document.querySelector('.add-profile');

    readonly sectionContent = document.querySelector(
        '.bx-soa-section-content.userinfo'
    );

    private static readonly fields = {
        email: 1,
        fio: 0,
        phone: 2,
    };

    init() {
        this.load();
        this.addEvents();
    }

    load() {
        let $phoneInput = $('input[type="tel"]');
        let self = this;
        $phoneInput.inputmask('mask', {'mask': window.arMaxOptions['THEME']['PHONE_MASK'] }).on('keyup', function(e){
            self.validatePhoneInput(e);
        });

        let $checkedProfile = $('.profile.checked');
        if($checkedProfile.length) {
            CheckoutComponent.arResult.USERINFO = {
                EMAIL: $checkedProfile.find('.email').text(),
                FIRST_NAME: $checkedProfile.find('.first_name').text(),
                LAST_NAME: $checkedProfile.find('.last_name').text(),
                PHONE: $checkedProfile.find('.phone').text(),
            };
            $('.add-profile-btn').show();
        } else {
            $('.profile-form').show();
        }
    }

    validatePhoneInput(e:any) {
        let val = $(e.target).val();
        let regexp = /\+7\s\([8|7](\d{2})\)\s(\d{1})(\d{2})-(\d{1})(\d{1})-(\d{1})(\d{1})/;
        if(val.match(regexp)) {
            $(e.target).val(val.replace(regexp, '+7 ($1$2) $3$4 $5$6 $7'));
        }
    }

    private addEvents() {
        let self = this;
        $('.buyer-profiles .profile').on('click', function(e){
           self.selectProfile(e);
        });
        $('.add-profile-btn').on('click', function(){
            self.showForm();
        });
        $('.buyer-profiles .profile-form')
            .find('input[type="text"], input[type="email"], input[type="tel"]')
            .on('change', () => {
                self.setProfileValues();
            });
        $('.action-auth-btn').on('click', function(){
            self.authorize();
        });
        $('.profile-form input').on('focusout', function(e){
            self.validateInput(e);
        });
    }

    validateInput(e: JQuery.ClickEvent<Document, undefined, any, any>)  {
        let $input = $(e.target);
        if($input.prop('name') == 'email') {
            if(/^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/.test($input.val())) {
                $input.parent('div').addClass('success-input').removeClass('error-input');
                $input.parent('div').find('.error-message').empty();
            } else {
                $input.parent('div').addClass('error-input').removeClass('success-input');
            }
        } else {
            if($input.val().length) {
                $input.parent('div').addClass('success-input').removeClass('error-input');
                $input.parent('div').find('.error-message').empty();
            } else {
                $input.parent('div').addClass('error-input').removeClass('success-input');
            }
        }
    }

    authorize() {
        let $authForm = $('.auth-form');
        $authForm.find('.error-message').empty();
        $.post(
            '/',
            {
                ajaxAction: 'authUser',
                email: $authForm.find('input[name="email"]').val(),
                pass: $authForm.find('input[name="pass"]').val(),
            },
            function(data) {
                if(data.status == 1) {
                    document.location.reload()
                } else {
                    $authForm.find('.error-message').html(data.status);
                }
            },
            'json'
        );
    }

    selectProfile(e: JQuery.ClickEvent<Document, undefined, any, any>) {
        $('.profile.checked').removeClass('checked');
        let $checkedProfile = $(e.target).closest('.profile');
        $checkedProfile.addClass('checked');
        CheckoutComponent.arResult.USERINFO = {
            EMAIL: $checkedProfile.find('.email').text(),
            FIRST_NAME: $checkedProfile.find('.first_name').text(),
            LAST_NAME: $checkedProfile.find('.last_name').text(),
            PHONE: $checkedProfile.find('.phone').text(),
        };
    }

    showForm() {
        $('.buyer-profiles .profile').hide();
        CheckoutComponent.arResult.USERINFO = null;
        $('.profile-form').show();
        $('.add-profile-btn').hide();
    }

    setProfileValues() {
        let $form = $('.profile-form');
        CheckoutComponent.arResult.USERINFO = {
            FIRST_NAME: $form.find('input[name="first_name"]').val().toString(),
            LAST_NAME: $form.find('input[name="last_name"]').val().toString(),
            EMAIL: $form.find('input[name="email"]').val().toString(),
            PHONE: $form.find('input[name="phone"]').val().toString(),
        };
    }

}
